import { render, staticRenderFns } from "./jwlProgrammeAddStudent.vue?vue&type=template&id=039380c2&lang=pug&"
import script from "./jwlProgrammeAddStudent.vue?vue&type=script&lang=js&"
export * from "./jwlProgrammeAddStudent.vue?vue&type=script&lang=js&"
import style0 from "./jwlProgrammeAddStudent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports